import { useNavigate } from "react-router-dom";

export const gameover = (navigate) => {

    navigate('/youaredead');
  };

